var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ui--wrapper fluid-width",
      class: {
        "ui---lnb-collapsed": _vm.isFoldSideMenu,
        // 'aside-hide': isHideSideMenu,
        "s-main": _vm.isHideSideMenu,
        "ui---lnb": !_vm.isHideSideMenu
      },
      attrs: { id: "mainWrapperDiv" }
    },
    [
      _c("top-menu", {
        on: {
          "router-reload": function($event) {
            return _vm.routerReload()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "ui--section-container", style: _vm.styleSet },
        [
          _vm.isRouterAlive ? _c("router-view") : _vm._e(),
          _vm._v(" "),
          !_vm.isHideSideMenu
            ? _c("side-menu", {
                on: {
                  "router-reload": function($event) {
                    return _vm.routerReload()
                  },
                  "fold-event": function($event) {
                    _vm.isFoldSideMenu = !_vm.isFoldSideMenu
                  },
                  "hide-event": _vm.displaySideMenu
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("offsider", {
            on: {
              "router-reload": function($event) {
                return _vm.routerReload()
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66935c84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66935c84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/MainPage.vue
// module id = null
// module chunks = 